<template>
<div>
<el-dialog  title="加工" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="jiagongFlag" width="1250px" center append-to-body>
  <div>
    <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
      <el-table height="90px" size="mini" border center bordersize="mini"  :data="[rowData]">
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" width="120"
          align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="仓位" width="160"
          align="center">
          <template slot-scope="scope1">
              <el-select clearable filterable v-model="goodform.stockWarehouseId" size="mini" >
                <el-option v-for="(item,index) in cwList" :key="index" :label="item.warehouseName" :value="item.stockWarehouseId"></el-option>
              </el-select>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="processVolume" label="加工量" width="120" align="center">
          <template >
            <el-input v-model="goodform.processVolume" maxlength="50" v-number-input.float="3"   size="mini" @input="weightInput">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="processNumber" label="加工件数" width="120" align="center">
          <template >
            <el-input v-model="goodform.processNumber" maxlength="50" v-number-input.float="0" @input="jianshuInput"  size="mini">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="detailsTitle" style="margin-top:20px">
        <h4>加工成品</h4>
        <el-button style="position:absolute;left:110px;" type="primary" @click="addtable">新增</el-button>
      </div>
      <el-table min-height="300px" max-height="350px" size="mini" border center bordersize="mini" ref="tableref"
        :data="chengpintable" style="width: 100%" class="elTab">
        <el-table-column prop="productType" label="货物类型" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.productType" size="mini" placeholder="请选择货物类型"
              @change="selectProductType(scope1.row)">
              <el-option v-for="(item, index) in huowuOptions" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.steelMillName" size="mini" placeholder="请选择产地"
              :disabled="scope1.row.disChandi" @change="selectChandi(scope1.row)">
              <el-option v-for="(item, index) in scope1.row.chanDiOptions" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.specification" size="mini" placeholder="请选择规格"
              :disabled="scope1.row.disGuige" @change="selectGuige(scope1.row)">
              <el-option v-for="(item, index) in scope1.row.guigeOptions" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="材质" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.model" size="mini" placeholder="请选择材质"
              :disabled="scope1.row.disCaizhi" @change="selectCaizhi(scope1.row)">
              <el-option v-for="(item, index) in scope1.row.caizhiOptions" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ownerCustomerTaxId" label="仓位" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.ownerCustomerTaxId" size="mini" placeholder="请选择仓位"
               @change="selectCW(scope1.row)">
              <el-option v-for="(item, index) in cwList1" :key="index" :label="item.warehouseName"
                :value="item.warehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="加工量" width="150"
          align="center">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.allWeight" maxlength="50" v-number-input.float="3"   size="mini" >
            </el-input>
          </template>
        </el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="number" label="加工件数" width="150"
          align="center">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.number" maxlength="50" v-number-input.float="0"   size="mini" >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center">
          <template slot-scope="scope1">
            <el-button @click="delClick(scope1.$index, scope1.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="saveFn()">提交</el-button>
  </span>
</el-dialog>
</div>
</template>

<script>
import { JfgetEmptyBillStockWarehouseInfo, getVirtualBalingList, getWeighingMethodList, coalProcess } from '@/api/wms-stock'
import { zidianKuwei } from '@/api/wms-access.js'
import { emptyFn, toFixed } from '@/utils/util'
export default {
  name: 'zhipaiyouhuo',
  props: {
    jiagongFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      goodform: {},
      rules: {
        orderWeight: [
          { required: true, message: '请输入调度量', trigger: 'blur' }
        ],
        vehicleNum: [
          { required: true, message: '请输入车数', trigger: 'blur' }
        ]
      },
      cwList: [],
      cwList1: [],
      huowuOptions: [],
      chengpintable: [{
        primaryCustomerName: this.rowData.primaryCustomerName,
        primaryCustomerTaxId: this.rowData.primaryCustomerTaxId,
        customerName: this.rowData.customerName,
        customerTaxId: this.rowData.customerTaxId,
        steelMillName: '',
        productType: '',
        productTypeName: '',
        specification: '',
        model: '',
        number: '',
        chanDiOptions: [],
        huowuOptions: [],
        guigeOptions: [],
        caizhiOptions: []
      }]
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    JfgetEmptyBillStockWarehouseInfo({
      primaryCustomerTaxId: this.rowData.primaryCustomerTaxId, // （一级货主id  必填）
      customerTaxId: this.rowData.customerTaxId, // （二级货主id 必填）
      productType: this.rowData.productType, // （货物类型id  非必填）
      steelMillName: this.rowData.steelMillName, // （产地  非必填）
      model: this.rowData.model, // （材质 非必填）
      specification: this.rowData.specification // （规格  非必填）
    }).then(res => {
      this.cwList = res.tEmptyStockWarehouseList
    }).catch(err => {
      this.$message.error(err.message)
    })
    zidianKuwei().then((res) => {
      this.cwList1 = res
    }).catch((err) => {
      console.log(err)
    })
    this.goodform.stockCustomerId = this.rowData.stockCustomerId
    getVirtualBalingList().then(res => {
      window.localStorage.setItem('HwInfos', JSON.stringify(res))
      let productArr = []
      res.forEach(item => {
        let obj = {}
        obj.id = item.productType
        obj.name = item.productTypeName
        productArr.push(obj)
      })
      const ress = new Map()
      let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
      this.huowuOptions = arrNew
    }).catch(err => {
      this.$message({ message: err.message, type: 'error' })
    })
  },
  methods: {
    saveFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (!this.goodform.stockWarehouseId) {
        this.$message({ message: '请选择仓位', type: 'error' })
        loading.close()
        return
      }
      if (!this.goodform.processVolume) {
        this.$message({ message: '请输入加工量', type: 'error' })
        loading.close()
        return
      }
      if (!this.goodform.processNumber) {
        this.$message({ message: '请输入件数', type: 'error' })
        loading.close()
        return
      }
      let flag = this.chengpintable.every(itme => itme.productType && itme.steelMillName && itme.specification && itme.model && itme.allWeight && itme.ownerCustomerTaxId && itme.number)
      if (!flag) {
        this.$message({ message: '请完善加工成品', type: 'error' })
        loading.close()
        return
      }
      let weight = 0
      let jianshu = 0
      this.chengpintable.forEach(item => {
        weight += Number(item.allWeight)
        jianshu += Number(item.number)
      })

      if (toFixed(this.goodform.processVolume, 3) != toFixed(weight, 3)) {
        this.$message({ message: '加工量与成品加工量不相等', type: 'error' })
        loading.close()
        return
      }
      if (toFixed(this.goodform.processNumber, 0) != toFixed(jianshu, 0)) {
        this.$message({ message: '加工件数与成品加工件数不相等', type: 'error' })
        loading.close()
        return
      }
      this.goodform.newList = this.chengpintable
      coalProcess(this.goodform).then(res => {
        loading.close()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.addFlag = false
        this.$emit('update:jiagongFlag', false)
        this.$parent.chaxun()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    weightInput () {
      console.log(this.goodform.processVolume)
      console.log(this.rowData.allWeight)
      if (this.goodform.processVolume > this.rowData.allWeight) {
        this.$message({ message: '加工量不能大于总重量', type: 'error' })
        this.$set(this.goodform, 'processVolume', null)
      }
    },
    jianshuInput () {
      if (this.goodform.processNumber > this.rowData.number) {
        this.$message({ message: '加工件数不能大于总件数', type: 'error' })
        this.$set(this.goodform, 'processNumber', null)
      }
    },
    addtable () {
      let obj = {
        primaryCustomerName: this.rowData.primaryCustomerName,
        primaryCustomerTaxId: this.rowData.primaryCustomerTaxId,
        customerName: this.rowData.customerName,
        customerTaxId: this.rowData.customerTaxId,
        steelMillName: '',
        productType: '',
        productTypeName: '',
        specification: '',
        model: '',
        number: '',
        chanDiOptions: [],
        huowuOptions: [],
        guigeOptions: [],
        caizhiOptions: []
      }
      this.chengpintable.push(obj)
    },
    delClick (index, row) {
      this.chengpintable.splice(index, 1)
    },
    selectProductType (row) {
      this.$set(row, 'steelMillName', '')
      this.$set(row, 'specification', '')
      this.$set(row, 'model', '')
      row.productTypeName = this.huowuOptions.filter(item => item.id == row.productType)[0].name
      getWeighingMethodList(
        {
          productType: row.productType
        }
      )
        .then(res => {
          if (res.length > 0) {
            row.inWeighingMethod = res[0].inWeighingMethod
            if (row.productType != '') {
              getVirtualBalingList(
                { ...row }
              )
                .then(res => {
                  row.chanDiOptions = Array.from(new Set(res.map(item => item.placeOfOrigin)))
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                })
            }
          } else {
            this.$message({ message: '计重方式未配置，请联系管理员', type: 'error' })
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    selectChandi (row) {
      this.$set(row, 'specification', '')
      this.$set(row, 'model', '')
      if (row.steelMillName != '') {
        getVirtualBalingList({ ...row })
          .then(res => {
            row.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }
    },
    selectGuige (row) {
      this.$set(row, 'model', '')
      if (row.specification != '') {
        getVirtualBalingList({ ...row })
          .then(res => {
            row.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }
    },
    selectCaizhi (row) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在处理...'
      // })
      // getVirtualBalingList({ ...row })
      //   .then(res => {
      //     loading.close()
      //     if (res.length > 0) {
      //       row.singletonWeight = res[0].weight
      //     }
      //   })
      //   .catch(err => {
      //     loading.close()

      //     this.$message({ message: err.message, type: 'error' })
      //   })
    },
    selectCW (row) {
      row.ownerCustomerName = this.cwList1.filter(item => item.warehouseId == row.ownerCustomerTaxId)[0].warehouseName
    },
    closeDialog () {
      this.$emit('update:jiagongFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>

</style>
